import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { interval, Subscription, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserStateService } from '../../services/user-state.service';

@Component({
  selector: 'app-login-form',
  template: require('./login-form.component.html'),
  styles: [require('./login-form.component.sass')]
})
export class LoginFormComponent implements OnInit {

  public loginForm: FormGroup;
  userIsBlocked$: Observable<boolean>;
  checkUserStatePeriod = 1000; // 1000 ms
  @Output() login = new EventEmitter<{
    username: string;
    password: string
  }>();
  
  constructor(
    private formBuilder: FormBuilder,
    private userStateService: UserStateService
    ) { 
    this.loginForm = this.formBuilder.group({
      username: [null, [Validators.required]],
      password: [null,[Validators.required]]
    });
    this.userIsBlocked$ = interval(this.checkUserStatePeriod).pipe(
        switchMap(() => of(this.userStateService.isUserBlocked()))
    );
  }

  ngOnInit(): void {

  }

  onLogin(): void {
    if (this.loginForm.valid) {
      this.login.emit(this.loginForm.value);
    }
  }
}
